module.exports = __webpack_public_path__ + "distVue/img/zaEmpty.29cd9741.png";